import { render, staticRenderFns } from "./ParentMenuItem.vue?vue&type=template&id=7cffde4c"
import script from "./ParentMenuItem.vue?vue&type=script&lang=js"
export * from "./ParentMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports